import { HTMLAttributes, forwardRef } from 'react';
import { foundationRadiusTokens, foundationSemantic } from '../../foundation';
import { cx } from './utils';

type SurfaceVariant = 'default' | 'muted' | 'elevated' | 'interactive';

interface SurfaceProps extends HTMLAttributes<HTMLDivElement> {
  variant?: SurfaceVariant;
}

const variantClasses: Record<SurfaceVariant, string> = {
  default: foundationSemantic.surface.default,
  muted: foundationSemantic.surface.muted,
  elevated: foundationSemantic.surface.elevated,
  interactive: foundationSemantic.surface.interactive
};

const Surface = forwardRef<HTMLDivElement, SurfaceProps>(function Surface(
  { variant = 'default', className, ...props },
  ref
) {
  return (
    <div
      ref={ref}
      className={cx(foundationRadiusTokens.xl, variantClasses[variant], className)}
      {...props}
    />
  );
});

export default Surface;
export type { SurfaceProps, SurfaceVariant };
